import Vue from 'vue';
import noty from './noty.service';

export default {
    async getGameProviders() {
        return (await Vue.http.get(`/api/games/providers`)).data;
    },
    async getGameCategories(clientId) {
        return (await Vue.http.get(`/api/games/byclient/${clientId}/categories`)).data;
    },
    async getClientGames(clientId, provider) {
        provider = provider || '';
        return (await Vue.http.get(`/api/games/byclient/${clientId}/${provider}`)).data;
    },
    async searchClientGames(clientId, term) {
        term = term || '';
        return (await Vue.http.get(`/api/games/byclient/${clientId}/search/${term}`)).data;
    },
    async byIds(gameIds) {
        gameIds = gameIds || [];
        return (await Vue.http.post('/api/games/byids', gameIds)).data;
    },
    async getBranchGames(clientId, branch, provider) {
        provider = provider || '';
        return (await Vue.http.get(`/api/games/bybranch/${clientId}/${branch}/${provider}`)).data;
    },
    async saveClientGame(game, clientId) {
        let g = (await Vue.http.post(`/api/games/save/client/${clientId}`, game)).data;
        noty.success(`${game.gameId} saved for client ${clientId}`);
        return g;
    },
    async saveBranchGame(game, clientId, branch) {
        let g = (await Vue.http.post(`/api/games/save/branch/${clientId}/${branch}`, game)).data;
        noty.success(`${game.gameId} saved for branch '${branch}'`);
        return g;
    },
    async syncProviderGamesForClientAsync(clientId, provider) {
        await Vue.http.post(`/api/games/sync/client/${clientId}/provider/${provider}`);
        noty.success(`${provider} games synced`);
    },
    async saveGameProperties(game) {
        let g = (await Vue.http.post(`/api/games/save/game/${game.id}`, game)).data;
        noty.success(`${game.name} properties saved`);
        return g;
    }
};



// WEBPACK FOOTER //
// ./src/services/game.service.js